"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountriesWithUsArtNr = void 0;
/**
 * Enum of all countries that use US article numbers.
 */
var CountriesWithUsArtNr;
(function (CountriesWithUsArtNr) {
    CountriesWithUsArtNr["US"] = "US";
    CountriesWithUsArtNr["MX"] = "MX";
    CountriesWithUsArtNr["CA"] = "CA";
})(CountriesWithUsArtNr = exports.CountriesWithUsArtNr || (exports.CountriesWithUsArtNr = {}));
//# sourceMappingURL=CountriesWithUsArtNr.js.map